var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpaces({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1657_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.04488 9.77698C4.89331 10.4287 3.9895 11.4429 3.4741 12.6616C2.9587 13.8803 2.86063 15.2353 3.19515 16.5155C3.52967 17.7957 4.27802 18.9295 5.32373 19.7403C6.36944 20.5511 7.65385 20.9935 8.97706 20.9986C10.3003 21.0037 11.5881 20.5713 12.64 19.7686C13.6919 18.9659 14.449 17.8379 14.7934 16.5603C15.1379 15.2827 15.0503 13.9271 14.5443 12.7044C14.0383 11.4817 13.1424 10.4606 11.9959 9.79998",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9971 20.196C13.112 20.8402 14.4046 21.1086 15.6838 20.9616C16.9631 20.8146 18.1611 20.26 19.1008 19.3797C20.0405 18.4993 20.6721 17.34 20.9022 16.0731C21.1324 14.8062 20.9488 13.4988 20.3787 12.3443C19.8085 11.1897 18.8821 10.2492 17.7363 9.66173C16.5904 9.07424 15.286 8.87097 14.0158 9.08194C12.7455 9.29292 11.5768 9.90695 10.6824 10.8333C9.78803 11.7596 9.21536 12.9491 9.04907 14.226",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.95 9.78498C17.9833 9.52764 18 9.26598 18 8.99998C17.9996 7.68201 17.5652 6.40085 16.764 5.35439C15.9628 4.30793 14.8393 3.55438 13.5671 3.21016C12.2949 2.86593 10.9447 2.95017 9.72515 3.44986C8.50559 3.94956 7.48449 4.83691 6.81956 5.97485C6.15464 7.11279 5.8829 8.43801 6.0463 9.7458C6.20971 11.0536 6.79918 12.2712 7.72365 13.2106C8.64813 14.1499 9.85618 14.7587 11.1612 14.943C12.4662 15.1272 13.7956 14.8767 14.944 14.23",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1657_53"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaces);
export default __webpack_public_path__ + "static/media/spaces.5daa6eea960ed2a63f220dd64bdc0a66.svg";
export { ForwardRef as ReactComponent };